import {
  MultiProcessOfferGroupStatusDto,
  OnUpdateMultiProcessOfferBeforePrintDataDto,
} from '@/api/generated';
import {
  ProcessOfferStatusOptionsTranslation,
  processOfferStatusOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { ProcessMultiOfferDialogModel } from '@/views/processes/multiOffer/components/dialog/model/ProcessMultiOfferDialog.model.ts';
import { ProcessMultiOfferCreateModel } from '@/views/processes/multiOffer/model/ProcessMultiOfferCreate.model.ts';

type StatusOptions = Record<MultiProcessOfferGroupStatusDto, string>;

const statusOptions: StatusOptions = {
  [MultiProcessOfferGroupStatusDto.Active]: 'Aktywna',
  [MultiProcessOfferGroupStatusDto.Canceled]: 'Anulowana',
  [MultiProcessOfferGroupStatusDto.Draft]: 'Szkic',
};

const offerPrint = 'Szablon oferty';

type Row = {
  name: string;
  offerPrint: string;
  status: string;
  totalGrossPrice: string;
  totalNetPrice: string;
  validTo: string;
};

const row: Row = {
  name: 'Nazwa',
  offerPrint,
  status: 'Status',
  totalGrossPrice: 'Cena brutto',
  totalNetPrice: 'Cena netto',
  validTo: 'Ważna do',
};

export type ProcessMultiOffersTranslation = {
  details: Row & {
    button: {
      print: string;
    };
    customerName: string;
    menu: {
      edit: string;
    };
    menuStatus: StatusOptions & {
      button: {
        changeStatus: string;
      };
    };
    noGroups: string;
    noOffers: string;
    offerActions: {
      open: string;
      preview: string;
      sent: string;
    };
    offerHead: {
      actions: string;
      creator: string;
      eventDateFrom: string;
      eventDateTo: string;
      name: string;
      noOfGuests: string;
      status: string;
    };
    offerPrint: string;
    processOfferStatusOptions: ProcessOfferStatusOptionsTranslation;
    statusOptions: StatusOptions;
  };
  dialog: {
    edit: {
      button: {
        cancel: string;
        submit: string;
      };
      form: Record<keyof ProcessMultiOfferDialogModel, string> & {
        statusOptions: StatusOptions;
      };
      title: string;
    };
    print: {
      button: {
        cancel: string;
        print: string;
      };
      form: Record<keyof OnUpdateMultiProcessOfferBeforePrintDataDto, string>;
      title: string;
    };
  };
  form: {
    button: {
      cancel: string;
      createOffer: string;
      goToMultiOffer: string;
      submit: string;
    };
    field: Record<keyof ProcessMultiOfferCreateModel, string>;
    noCustomerAlert: string;
    title: string;
  };
  table: {
    head: Row;
  };
  title: string;
};

export const processMultiOffersTranslation: ProcessMultiOffersTranslation = {
  details: {
    button: {
      print: 'Pobierz ofertę',
    },
    ...row,
    customerName: 'Klient',
    menu: {
      edit: 'Edytuj',
    },
    menuStatus: {
      ...statusOptions,
      button: {
        changeStatus: 'Zmień status',
      },
    },
    noGroups: 'Brak grup ofert',
    noOffers: 'Brak ofert w tej grupie',
    offerActions: {
      open: 'Otwórz ofertę',
      preview: 'Podgląd PDF',
      sent: 'Wysłana {{date}} — zablokowana, zmiany tylko w nowej wersji',
    },
    offerHead: {
      actions: 'Akcje',
      creator: 'Twórca',
      eventDateFrom: 'Od',
      eventDateTo: 'Do',
      name: 'Nazwa',
      noOfGuests: 'Liczba gości',
      status: 'Status',
    },
    offerPrint,
    processOfferStatusOptions: processOfferStatusOptionsTranslation,
    statusOptions,
  },
  dialog: {
    edit: {
      button: {
        cancel: 'Anuluj',
        submit: 'Zapisz',
      },
      form: {
        name: 'Nazwa',
        offerPrint,
        status: 'Status',
        statusOptions,
        validTo: 'Ważna do',
      },
      title: 'Edycja grupy ofert',
    },
    print: {
      button: {
        cancel: 'Anuluj',
        print: 'Drukuj',
      },
      form: {
        createTaskOfferEnd: 'Utworzyć przypomnienie o końcu wązności oferty?',
        validTo: 'Ważna do',
      },
      title: 'Drukuj ofertę',
    },
  },
  form: {
    button: {
      cancel: 'Wróć do procesu',
      createOffer: 'Dodaj ofertę',
      goToMultiOffer: 'Przejdź do grupy ofert',
      submit: 'Zapisz',
    },
    field: {
      name: 'Nazwa',
      offerPrint,
    },
    noCustomerAlert: 'Aby utworzyć grupę ofert, należy najpierw przypisać klienta do procesu.',
    title: 'Podaj parametry tworzonej grupy ofert',
  },
  table: {
    head: row,
  },
  title: 'Grupy ofert',
};
